module.exports = __webpack_public_path__ + "img/price_type_2.50d0f5d5.png";